import { useContext, useEffect } from "react"
import { dispatcher_context } from "./hooks/useStats_dispatcher"
import { RSODynamicDispDynamic } from "./components/RSODynamicDispDynamic/RSODynamicDispDynamic";
import { RSODynamicDispDateReport } from "./components/RSODynamicDispDateReport/RSODynamicDispDateReport";
import { RSODynamicDispEquipmentFailures } from "./components/RSODynamicDispEquipmentFailures/RSODynamicDispEquipmentFailures";
import { RSODynamicDispDynamicDetailWPS } from "./components/RSODynamicDispDynamicDetailWPS/RSODynamicDispDynamicDetailWPS";

const serviceTabs = [
  'Динамическая информация',
  'Отчет за дату',
  'Отказы оборудования',
  'ВЗУ детально',
];

const dynamicTabs = [
  'Оперативные данные',
  'Дневной отчет',
];

const rsoDynamicTargetStorageKey = 'rso-dynamic-menu-target';

export let RSODynamicDispatcher = () => {

  let { activeTab, dynamicActiveTab, setActiveTab, setDynamicActiveTab } = useContext(dispatcher_context);

  useEffect(() => {
    const savedTarget = sessionStorage.getItem(rsoDynamicTargetStorageKey);

    if (!savedTarget) {
      return;
    }

    let target;

    try {
      target = JSON.parse(savedTarget);
    } catch {
      sessionStorage.removeItem(rsoDynamicTargetStorageKey);
      return;
    }

    if (target.activeTab) {
      setActiveTab(target.activeTab);
    }

    if (target.dynamicActiveTab) {
      setDynamicActiveTab(target.dynamicActiveTab);
    }

    sessionStorage.removeItem(rsoDynamicTargetStorageKey);
  }, [setActiveTab, setDynamicActiveTab]);

  useEffect(() => {
    window.dispatchEvent(new CustomEvent('page-services:update', {
      detail: {
        title: 'Сервисы',
        items: serviceTabs.map(title => {
          const isDynamic = title === 'Динамическая информация';

          return {
            title,
            active: activeTab === title,
            onClick: () => setActiveTab(title),
            children: isDynamic ? dynamicTabs.map(childTitle => ({
              title: childTitle,
              active: activeTab === title && dynamicActiveTab === childTitle,
              onClick: () => {
                setActiveTab(title);
                setDynamicActiveTab(childTitle);
              },
            })) : undefined,
          };
        }),
      },
    }));

    return () => {
      window.dispatchEvent(new CustomEvent('page-services:update', {
        detail: { title: 'Сервисы', items: [] },
      }));
    };
  }, [activeTab, dynamicActiveTab, setActiveTab, setDynamicActiveTab]);

  return (
    <div className="large__container RSODynamic-page">
      {activeTab === "ВЗУ детально" &&
        <RSODynamicDispDynamicDetailWPS />}

      {activeTab === "Отчет за дату" &&
        <RSODynamicDispDateReport />}

      {activeTab === "Динамическая информация" &&
        <RSODynamicDispDynamic />}

      {activeTab === "Отказы оборудования" &&
        <RSODynamicDispEquipmentFailures />}
    </div>
  )
}
